import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/dolgunun-erime-suresi-ne-zaman-ve-neden-azalir/page.tsx");
